import styles from './ContentLayout.module.scss'
import {FC, ReactNode} from "react";
import {Typography} from "@shared/ui/Typography/Typography";
import {TContentLayoutRootProps, TContentProps, THeaderProps} from "../../ui/ContentLayout/types";
import {observer} from "mobx-react-lite";
import {Button} from "@shared/ui/Button";

export const ContentLayoutRoot: FC<TContentLayoutRootProps> = (
    {
        children
    }: { children: ReactNode}) => {

    return (
        <div className={`${styles.root} `}>
            {children}
        </div>
    )
}

export const Header: FC<THeaderProps> = observer(({children, title}) => {

    return (
        <div className={styles.header}>
            <div className={styles.title}>
                <Typography type={"span"} noWrap adaptiveFontSize={0.7} fontWeight={"bold"} align={"center"}>
                    {title}
                </Typography>
            </div>
            <div className={styles.actions}>
                {children}
            </div>

        </div>
    )
})

export const Content: FC<TContentProps> = observer(({children}) => {

    return (
        <div className={styles.content}>
            {children}
        </div>
    )
})



